<template>
    <b-form-input
        id="input-talk-feedbacks-filter-date"
        :placeholder="placeholder"
        v-model="date"
        class="date-input"
        :value="inputValue"
        v-on="inputEvents"
        readonly
        :state="state"
        autocomplete="off"
    ></b-form-input>
</template>

<script>
import { getStringFromDateWithoutTime } from '@/lib/date'

export default {
    name: 'DateInput',
    props: {
        value: {
            type: Date,
            default: new Date(),
        },
        placeholder: String,
        inputValue: {
            required: true,
        },
        inputEvents: {
            required: true,
        },
        state: {
            required: false,
            default: null,
        },
    },
    computed: {
        date: {
            get: function () {
                if (!this.value) {
                    return null
                }
                return getStringFromDateWithoutTime(this.value)
            },
            set: function (value) {
                this.value = value
            },
        },
    },
}
</script>

<style lang="sass" scoped>
.date-input
    margin-left: 10px
    width: 137px
    background-color: #fff
</style>
